/**
 * Colours for /home, kept in one place because the light LNVG-derived styling is
 * provisional — the review may move the page onto the app's dark navy/amber
 * chrome, which should then be a change to this file and nothing else.
 */
export const HOME_PALETTE = {
  navBg:      '#1e1b4b',
  navBorder:  'rgba(255,255,255,0.25)',
  navFgIdle:  'rgba(255,255,255,0.65)',
  accent:     '#f0997b',
  pageBg:     '#f4f5f7',
  cardBg:     '#ffffff',
  cardBorder: '#e4e4e7',
  textStrong: '#18181b',
  textMuted:  '#71717a',
  textFaint:  '#a1a1aa',
  positive:   '#3b6d11',
  negative:   '#a32d2d',
  accentCard:     '#2a78d6',
  accentCardText: '#ffffff',
  alarmCard:      '#f09595',
  alarmCardText:  '#501313',
  series: {
    occupied:   '#2a78d6',
    free:       '#d3d1c7',
    medical:    '#2a78d6',
    aggression: '#4a3aa7',
    fire:       '#eb6834',
  },
} as const;
